module.exports = __webpack_public_path__ + "static/media/arrow_up.3b859460.svg";